export const APPOINTMENT_OVERLAPPING = 'There is already an appointment during selected hours';
export const APPOINTMENT_TO_DATE_LESS_THAN_FROM = 'Appointment start time shouldn\'t be less then finish time';
export const APPOINTMENT_ALREADY_BOOKED_BY_REP = 'Rep already booked appointment in selected date';
export const APPOINTMENT_FREQUENCY_LIMIT = {
  header: 'Appointment limit met',
  body: 'Oh No! You\'ve already met the appointment frequency limit for this quarter.'
};
export const APPOINTMENT_ALREADY_BOOKED = {
  header: 'Appointment already booked',
  body: 'Oh no! It looks like someone else has already booked this appointment.'
};
export const APPOINTMENT_REP_BLOCKED = {
  header: 'You are blocked by this office',
  body: 'For clarification please contact the office.'
};
export const DATA_EDIT_SUCCESS = 'Your data has been changed';
export const DATA_EDIT_ERROR = 'Your data has not been changed. Check if you filled in all data correct';
export const APPOINTMENT_CANCELLED_SUCCESS = 'You cancelled selected appointment';
export const APPOINTMENT_CLOSED_SUCCESS = 'You closed selected appointment';
export const APPOINTMENT_CONFIRMED_SUCCESS = 'You confirmed selected appointment';
export const ACTIVATE_REP_ERROR = 'Something went wrong. Please try again';
export const ACTIVATE_REP_SUCCESS = 'You are marked as an active user';
export const FREE_STANDING_APPOINTMENT_BLOCKED_REP_ERROR = 'Selected rep is blocked by you';
export const BLOCK_REP_SUCCESS = 'You blocked selected rep';
export const BLOCK_REP_ERROR = 'Something went wrong. Please try again';
export const UNBLOCK_REP_SUCCESS = 'You unblocked selected rep';
export const UNBLOCK_REP_ERROR = 'Something went wrong. Please try again';
export const BOOK_CREATE_SUCCESS = 'You opened book in selected quarter';
export const BOOK_CREATE_ERROR = 'Something went wrong. Please try again';
export const FREE_STANDING_APPOINTMENT_CREATE_SUCCESS = 'You added new free standing appointment';
export const FREE_STANDING_APPOINTMENT_CREATE_ERROR = 'Something went wrong. Please try again';
export const DOCTOR_CREATE_SUCCESS = 'You created new doctor';
export const DOCTOR_CREATE_ERROR = 'Something went wrong. Please try again';
export const DOCTOR_EDIT_SUCCESS = 'You edited selected doctor';
export const DOCTOR_EDIT_ERROR = 'Something went wrong. Please try again';
export const DOCTOR_AVAILABILITIES_CHANGE_SUCCESS = 'You changed doctors availabilities in selected day';
export const DOCTOR_AVAILABILITIES_CHANGE_ERROR = 'Something went wrong. Please try again';
export const UPDATE_PAYMENT_DETAILS_SUCCESS = 'You edited your payment details';
export const UPDATE_PAYMENT_DETAILS_ERROR = 'Something went wrong. Please try again';
export const RENEW_SUBSCRIPTION_SUCCESS = 'You renewed your subscription';
export const RENEW_SUBSCRIPTION_ERROR = 'Something went wrong. Please try again';
export const CANCEL_SUBSCRIPTION_SUCCESS = 'You cancelled your subscription';
export const CANCEL_SUBSCRIPTION_ERROR = 'Something went wrong. Please try again';
export const BOOK_FOLLOW_SUCCESS = 'You are following selected office';
export const BOOK_UNFOLLOW_SUCCESS = 'You unfollowed selected office';
export const SEND_MESSAGE_SUCCESS = 'You sent trade request message';
export const SEND_MESSAGE_ERROR = 'Something went wrong. Please try again';
export const SEND_MESSAGE_NOT_AUTH = 'Action allowed for Premium users only';
export const ACCEPT_TRADE_OFFER_SUCCESS = 'You accepted selected trade request';
export const ACCEPT_TRADE_OFFER_ERROR = 'Something went wrong. Please try again';
export const REJECT_TRADE_OFFER_SUCCESS = 'You rejected selected trade request';
export const REJECT_TRADE_OFFER_ERROR = 'Something went wrong. Please try again';
export const RECOMMEND_OFFICE_SUCCESS = 'You sent product/service recommendation on selected email';
export const RECOMMEND_OFFICE_ERROR = 'Something went wrong. Please try again';
export const POST_NEW_TRADE_OFFER_SUCCESS = 'You posted trade request';
export const POST_NEW_TRADE_OFFER_ERROR = 'Something went wrong. Please try again';
export const POST_NEW_TRADE_OFFER_NOT_AUTH = 'Action allowed for Premium users only';
export const SEND_MASS_EMAIL_MESSAGE_SUCCESS = 'You sent email message';
export const SEND_MASS_EMAIL_MESSAGE_ERROR = 'Something went wrong. Please try again';
export const CANCEL_TRADE_REQUEST_SUCCESS = 'You cancelled selected trade request';
export const CANCEL_TRADE_REQUEST_ERROR = 'Something went wrong. Please try again';



// WEBPACK FOOTER //
// ./app/constants/messages.js